import { render, staticRenderFns } from "./WhatWeDo.vue?vue&type=template&id=47c2905f&scoped=true&"
import script from "./WhatWeDo.vue?vue&type=script&lang=js&"
export * from "./WhatWeDo.vue?vue&type=script&lang=js&"
import style0 from "./WhatWeDo.vue?vue&type=style&index=0&id=47c2905f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c2905f",
  null
  
)

export default component.exports